/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('../icons/icons.font');

import Vue from 'vue'

import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import pathToRegexp from 'path-to-regexp'

import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueUniqueId from 'vue-unique-id'
import VueClipboard from 'vue-clipboard2'

Vue.use(BootstrapVue)

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueUniqueId);
Vue.use(VueClipboard)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Object.defineProperty(Vue.prototype, '$_', {
  get () { return _ }
})

Object.defineProperty(Vue.prototype, '$w', {
  get () { return window }
})

Object.defineProperty(Vue.prototype, '$url', {
  get() { return require('./route') }
})

const store = new Vuex.Store(require('./utils/EventBus').default)

/**
 * Create an axios instance for private use
 */
Vue.prototype.$http = axios.create({
  timeout: 15000,
  baseURL: window.server.baseURL,
  headers: {
    'X-CSRF-TOKEN': window.server.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
  },
})

Vue.prototype.$http.interceptors.response.use((response) => {
  store.dispatch('interceptResponse', response)
  return response
}, (error) => {
  store.dispatch('interceptResponse', error.response)
  return Promise.reject(error)
})

window.$http = Vue.prototype.$http

Vue.component('confirm-button', require('./components/ConfirmButton.vue').default)

Vue.component('account-edit', require('./components/account/AccountEdit.vue').default)
Vue.component('account-switcher', require('./components/account/AccountSwitcher.vue').default)

Vue.component('customer-edit', require('./components/customer/CustomerEdit.vue').default)

Vue.component('user-edit', require('./components/user/UserEdit.vue').default)

Vue.component('testcampaign', require('./components/testcampaign/TestCampaignContainer.vue').default)
Vue.component('testcampaign-steps', require('./components/testcampaign/TestCampaignSteps.vue').default)
Vue.component('testcampaign-select', require('./components/testcampaign/TestCampaignSelect.vue').default)


import TestCampaignFinalize from './components/testcampaign/TestCampaignFinalize.vue'
import TestCampaignTest from './components/testcampaign/TestCampaignSelect.vue'

Vue.component('testcampaign-test', TestCampaignTest)
Vue.component('testcampaign-finalize', TestCampaignFinalize)

Vue.component('setup-view', require('./components/import/SetupView.vue').default)
Vue.component('import-pair', require('./components/import/ImportPair.vue').default)
Vue.component('import-errors', require('./components/import/ImportErrors.vue').default)

Vue.component('profile-user', require('./components/profile/ProfileUser.vue').default)
Vue.component('profile-customer', require('./components/profile/ProfileCustomer.vue').default)

Vue.component('statistics-container', require('./components/results/StatisticsContainer.vue').default)

Vue.component('pool-overview', require('./components/pools/partials/PoolOverview.vue').default)
Vue.component('state-overview', require('./components/pools/partials/StateOverview.vue').default)

Vue.component('purchase-modal', require('./components/purchases/PurchaseModal.vue').default)
Vue.component('purchases-table', require('./components/purchases/PurchasesTable.vue').default)

Vue.component('subscription-modal', require('./components/subscriptions/SubscriptionModal.vue').default)
Vue.component('subscriptions-table', require('./components/subscriptions/SubscriptionsTable.vue').default)
Vue.component('subscriptions-section', require('./components/subscriptions/SubscriptionsSection.vue').default)

Vue.component('pools-table', require('./components/pools/PoolsTable.vue').default)

Vue.component('export-tests', require('./components/export/Tests.vue').default)

const router = new VueRouter({
  routes: [
    {
      path: '',
      meta: {
        indexes: {
          '/test-campaigns/create': '/tc/create',
          '/test-campaigns/:id/edit': '/tc/edit'
        }
      }
    },
    {
      path: '/tc/create',
      component: TestCampaignTest,
      meta: {
        step: 1
      }
    },
    {
      path: '/tc/edit',
      component: TestCampaignTest,
      meta: {
        step: 2
      }
    },
    {
      path: '/tc/finalize',
      component: TestCampaignFinalize,
      meta: {
        step: 3
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(typeof to.meta.indexes === 'undefined') {
    next()
  }

  var redirect = undefined

  _.forEach(to.meta.indexes, (target, pattern) => {
    var keys = []
    var re = pathToRegexp(pattern, keys)

    var result = re.exec(window.location.pathname)
    if(result !== null) {
      redirect = target
      return false
    }
  })


  next(redirect)
})

import Highcharts from 'highcharts'
import streamgraphInit from 'highcharts/modules/streamgraph'
import More from 'highcharts/highcharts-more';

streamgraphInit(Highcharts)
More(Highcharts)

Object.defineProperty(Vue.prototype, '$hc', {
  get() {
    return Highcharts
  }
})

Vue.prototype.$u = {
  is: (value, other) => typeof value === typeof other
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.Vue = new Vue({  // eslint-disable-line
  el: '#app',
  router,
  store,
  methods: {
    getPreference(name, defaultValue) {
      var key = `lingusta.preferences.${name}`
      var value = window.localStorage.getItem(key)

      if (value === null) {
        this.setPreference(name, defaultValue)
        value = defaultValue
      }

      if(typeof defaultValue === 'number') {
        return parseInt(value)
      } else {
        return value
      }
    },
    setPreference(name, value) {
      var key = `lingusta.preferences.${name}`
      window.localStorage.setItem(key, value)
    }
  },
  created() {
    if (typeof window.global !== 'undefined') {
      this.$store.dispatch('loadGlobal', window.global)
    }
  }
});
